import TreeSelect from 'bee-tree-select'

export default TreeSelect
